export const formatToPercentage = (
  value: number,
  { compact = false } = {}
) =>
  (value / 100).toLocaleString(undefined, {
    style: "percent",
    maximumFractionDigits: compact ? 0 : 2,
  })
